module.exports = __webpack_public_path__ + "img/5.d81eae30.jpg";